/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side-by-side boxes make group differences easy to compare.`)
};

const es_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cajas una junto a otra facilitan comparar las diferencias entre grupos.`)
};

const de_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebeneinanderstehende Boxen erleichtern den Vergleich von Gruppenunterschieden.`)
};

const nl_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boxen naast elkaar maken groepsverschillen eenvoudig te vergelijken.`)
};

const fr_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des boîtes côte à côte facilitent la comparaison des différences entre groupes.`)
};

const it_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatole affiancate rendono facile confrontare le differenze tra gruppi.`)
};

const pt_br2_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixas lado a lado facilitam a comparação entre grupos.`)
};

const pt_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixas lado a lado facilitam a comparação das diferenças entre grupos.`)
};

const ja_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱を並べることで、グループ間の違いを比較しやすくなります。`)
};

const zh_box_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`并排的箱子便于比较各组之间的差异。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_ex3", locale)
	if (locale === "en") return en_box_ex3(inputs)
	if (locale === "es") return es_box_ex3(inputs)
	if (locale === "de") return de_box_ex3(inputs)
	if (locale === "nl") return nl_box_ex3(inputs)
	if (locale === "fr") return fr_box_ex3(inputs)
	if (locale === "it") return it_box_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_box_ex3(inputs)
	if (locale === "pt") return pt_box_ex3(inputs)
	if (locale === "ja") return ja_box_ex3(inputs)
	return zh_box_ex3(inputs)
};